import http from '../utils/http';

// 获取操作类型列表
export const getOperationTypes = () => {
  return http.get('/api/HistoryRecord/GetOperationTypes');
};

// 分页获取历史记录
export const getPageData = (params) => {
  return http.post('/api/HistoryRecord/GetPageData', params);
};

// 删除历史记录
export const deleteHistoryRecord = (id) => {
  return http.delete(`/api/HistoryRecord/Delete?Id=${id}`);
};

// 获取历史记录详情
export const GetGroupByRecordId = (id) => {
  return http.get(`/api/HistoryRecord/GetGroupByRecordId?Id=${id}`);
};
